/* ============================================================
 * V6 Pattern A Reviews — pick top 3 products, render review cards
 * with horizontal photo-review carousel from loox-reviews-data.json
 * ============================================================ */
(function () {
  'use strict';

  var reviewsCache = null;
  var reviewsCachePromise = null;

  function loadReviewsData() {
    if (reviewsCache) return Promise.resolve(reviewsCache);
    if (reviewsCachePromise) return reviewsCachePromise;

    var section = document.querySelector('[data-section="cust-v6-pattern-a-reviews"]');
    var url = section && section.getAttribute('data-reviews-url');

    if (!url) {
      console.warn('[Pattern A] data-reviews-url not found on section root, JSON cannot be fetched');
      reviewsCache = {};
      return Promise.resolve({});
    }

    console.log('[Pattern A] Fetching reviews JSON from:', url);
    reviewsCachePromise = fetch(url)
      .then(function (r) {
        console.log('[Pattern A] JSON fetch status:', r.status, r.ok);
        return r.ok ? r.json() : {};
      })
      .then(function (data) {
        console.log('[Pattern A] JSON loaded with', Object.keys(data).length, 'product handles');
        reviewsCache = data;
        return data;
      })
      .catch(function (err) {
        console.warn('[Pattern A] Reviews data fetch failed', err);
        reviewsCache = {};
        return {};
      });

    return reviewsCachePromise;
  }

  function processPatternA(snap) {
    var root = document.querySelector('[data-section="cust-v6-pattern-a-reviews"]');
    if (!root) return;

    var staging = root.querySelector('[data-pattern-a-staging]');
    var track = root.querySelector('[data-pattern-a-track]');
    if (!staging || !track) return;

    updateTitle(root, snap);
    updateViewAll(root);

    /* Bryce 2026-05-05: Pattern A must always reach 3 visible cards. The
       static loox-reviews-data.json can lag the metafield (a SKU is tagged
       with num_reviews>0 in Liquid staging but the JSON regen hasn't run
       yet), which is what was reducing the section to 2 cards on
       Peach-Hibiscus filters. Gate picks by JSON presence so unavailable
       handles never reach the rendered track in the first place — the
       post-render hide path is now only a defensive last resort. */
    loadReviewsData().then(function (reviews) {
      var picks = pickTop3(staging, snap, reviews);

      if (picks.length === 0) {
        root.style.display = 'none';
        return;
      }
      root.style.display = '';

      track.innerHTML = '';
      picks.forEach(function (card) {
        var instance = card.cloneNode(true);
        instance.removeAttribute('hidden');
        track.appendChild(instance);
      });

      // Render review tiles into carousels (data already loaded — no second fetch)
      renderReviewTilesForActiveCards(reviews);
    });
  }

  function renderReviewTilesForActiveCards(reviewsArg) {
    var doRender = function (reviews) {
      var track = document.querySelector('[data-pattern-a-track]');
      if (!track) return;

      var cards = track.querySelectorAll('[data-product-handle]');
      cards.forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        var carousel = card.querySelector('[data-loox-carousel]');
        var desc = card.querySelector('[data-desc-fallback]');
        if (!carousel) return;

        var productReviews = reviews[handle] || [];
        if (productReviews.length === 0) {
          /* pickTop3 already filtered handles with no JSON reviews. We only
             reach this branch when the picker was forced to include a
             JSON-less card to fill 3 slots (i.e., not enough reviewable
             products in staging). Hide the carousel and surface description
             text — never expose product copy in a review tile slot. */
          var article = card.closest('.v-par__card') || card;
          article.style.display = 'none';
          article.setAttribute('aria-hidden', 'true');
          return;
        }

        carousel.innerHTML = '';
        productReviews.forEach(function (rev) {
          carousel.innerHTML += renderTile(rev);
        });
        carousel.hidden = false;
        if (desc) desc.hidden = true;
      });
    };

    if (reviewsArg) {
      doRender(reviewsArg);
    } else {
      loadReviewsData().then(doRender);
    }
  }

  function renderTile(rev) {
    var rating = parseInt(rev.r, 10) || 5;
    var stars = '';
    var i;
    for (i = 0; i < rating; i++) stars += '\u2605';
    for (i = rating; i < 5; i++) stars += '\u2606';

    var verifiedBadge = rev.v ? '<span class="v-par__tile-verified">\u2713 Verified</span>' : '';
    var dateShort = '';
    if (rev.d) {
      try {
        var dt = new Date(rev.d);
        dateShort = dt.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      } catch (e) {}
    }

    var escapedBody = escapeHTML(rev.b || '');
    var escapedName = escapeHTML(rev.n || '');

    return '<article class="v-par__tile">' +
      '<img class="v-par__tile-img" src="' + (rev.i || '') + '" alt="" loading="lazy">' +
      '<div class="v-par__tile-body">' +
        '<span class="v-par__tile-stars" aria-label="' + rating + ' of 5">' + stars + '</span>' +
        '<p class="v-par__tile-text">' + escapedBody + '</p>' +
        '<div class="v-par__tile-meta">' +
          '<span>' + escapedName + '</span>' +
          verifiedBadge +
          (dateShort ? '<span>\u00b7 ' + dateShort + '</span>' : '') +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function escapeHTML(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function pickTop3(staging, snap, reviews) {
    var allCards = Array.prototype.slice.call(staging.querySelectorAll('.v-par__card'));

    /* JSON gate: a card "has reviews" if loox-reviews-data.json includes
       at least one tile for its handle. When the JSON failed to load
       (reviews is an empty object) we don't gate — better to render with
       desc fallback than empty the section. */
    var jsonLoaded = reviews && Object.keys(reviews).length > 0;
    function cardHasJsonReviews(card) {
      if (!jsonLoaded) return true;
      var h = card.getAttribute('data-product-handle');
      return ((reviews[h] || []).length > 0);
    }

    function sortByPriority(a, b) {
      var pa = parseInt(a.getAttribute('data-filter-priority') || '50', 10);
      var pb = parseInt(b.getAttribute('data-filter-priority') || '50', 10);
      if (pb !== pa) return pb - pa;
      return 0;
    }

    /* Mirror Top Matches' picks so the 3 review cards line up exactly with
       the products Top Picks just rendered. The controller exposes the
       handles via window.VioriFilters.getTopMatchesHandles() and that's the
       single source of truth — both sections used to run their own divergent
       sort logic which is what caused them to drift apart.

       Bryce 2026-05-05: walk all available Top Matches handles (controller
       now returns up to 10), skipping any whose product has no entries in
       loox-reviews-data.json. This guarantees a renderable card for every
       slot we fill — no more post-render hides reducing the section to 2. */
    var picks = [];
    if (window.VioriFilters && typeof window.VioriFilters.getTopMatchesHandles === 'function') {
      var handles = window.VioriFilters.getTopMatchesHandles(snap) || [];
      if (handles.length > 0) {
        var byHandle = {};
        allCards.forEach(function (c) {
          byHandle[c.getAttribute('data-product-handle')] = c;
        });
        for (var i = 0; i < handles.length && picks.length < 3; i++) {
          var card = byHandle[handles[i]];
          if (card && cardHasJsonReviews(card)) picks.push(card);
        }
        /* Backfill from priority sort, requiring JSON reviews. Triggered
           when fewer than 3 of Top Matches' picks have JSON entries. */
        if (picks.length < 3) {
          var pickedHandles = {};
          picks.forEach(function (c) { pickedHandles[c.getAttribute('data-product-handle')] = true; });
          var rest = allCards.slice().sort(sortByPriority).filter(function (c) {
            if (pickedHandles[c.getAttribute('data-product-handle')]) return false;
            return cardHasJsonReviews(c);
          });
          while (picks.length < 3 && rest.length > 0) {
            picks.push(rest.shift());
          }
        }
        /* Last-resort defense: if STILL <3 (i.e., fewer than 3 reviewable
           products exist across staging + Top Matches), allow JSON-less
           cards. The renderer will hide their carousels and the desc
           fallback path takes over for those tiles. */
        if (picks.length < 3) {
          var picked2 = {};
          picks.forEach(function (c) { picked2[c.getAttribute('data-product-handle')] = true; });
          var any = allCards.slice().sort(sortByPriority).filter(function (c) {
            return !picked2[c.getAttribute('data-product-handle')];
          });
          while (picks.length < 3 && any.length > 0) {
            picks.push(any.shift());
          }
        }
        return picks;
      }
    }

    /* Fallback if Top Matches isn't on the page or its API isn't available
       yet — shouldn't happen in practice but keeps Pattern A renderable in
       isolation (e.g., a page that has Reviews but no Top Picks). */
    var hasFilter = hasAnyFilter(snap);
    var sorted = allCards.slice().sort(sortByPriority);
    var sortedWithReviews = sorted.filter(cardHasJsonReviews);

    if (hasFilter) {
      picks = sortedWithReviews.slice(0, 3);
      if (picks.length < 3) {
        var pickedH3 = {};
        picks.forEach(function (c) { pickedH3[c.getAttribute('data-product-handle')] = true; });
        var fb3 = sorted.filter(function (c) { return !pickedH3[c.getAttribute('data-product-handle')]; });
        while (picks.length < 3 && fb3.length > 0) picks.push(fb3.shift());
      }
      return picks;
    }
    var popular = sortedWithReviews.filter(function (c) {
      var status = (c.getAttribute('data-product-status') || '').toLowerCase();
      return status.indexOf('most popular') !== -1 || status.indexOf('best seller') !== -1;
    });
    picks = popular.slice(0, 3);
    if (picks.length < 3) {
      var pickedIds = {};
      picks.forEach(function (c) { pickedIds[c.getAttribute('data-product-id')] = true; });
      var fallbackRest = sortedWithReviews.filter(function (c) { return !pickedIds[c.getAttribute('data-product-id')]; });
      while (picks.length < 3 && fallbackRest.length > 0) {
        picks.push(fallbackRest.shift());
      }
    }
    if (picks.length < 3) {
      var pickedIds2 = {};
      picks.forEach(function (c) { pickedIds2[c.getAttribute('data-product-id')] = true; });
      var anyRest = sorted.filter(function (c) { return !pickedIds2[c.getAttribute('data-product-id')]; });
      while (picks.length < 3 && anyRest.length > 0) picks.push(anyRest.shift());
    }
    return picks;
  }

  function hasAnyFilter(snap) {
    if (!snap) return false;
    var keys = ['scalp_types', 'concerns', 'benefits', 'product_types', 'hair_likenesses'];
    for (var i = 0; i < keys.length; i++) {
      if (snap[keys[i]] && snap[keys[i]].length > 0) return true;
    }
    return false;
  }

  function updateTitle(root, snap) {
    var el = root.querySelector('[data-pattern-a-title]');
    if (!el) return;

    // Skip if this section's filter-aware toggle is off
    if (el.dataset.genFilterAware === 'false') return;

    var prefix = el.dataset.genPrefix || 'Customer Reviews';
    var sparkles = el.dataset.genSparkles !== 'false';

    // Use the shared formula from the filter controller so the Reviews title
    // reads identically to Best Sellers / Recommended:
    //   default → "Customer Reviews"
    //   filtered → "Customer Reviews for <adjectives> Hair that needs <benefits>"
    // Bryce 2026-05-05: buildFilterTitle returns HTML markup wrapping the
    // dynamic suffix in <span class="v-filter-title__dynamic">, so this MUST
    // assign via innerHTML — textContent escapes the tags and renders the
    // raw HTML as text. Top Matches and Recommended For both use innerHTML
    // for the same reason.
    if (window.VioriFilters && typeof window.VioriFilters.buildFilterTitle === 'function') {
      el.innerHTML = window.VioriFilters.buildFilterTitle(prefix, snap || {}, { sparkles: sparkles });
      return;
    }

    // Fallback if controller hasn't loaded yet (rare; controller boots first).
    el.textContent = prefix;
  }

  function updateViewAll(root) {
    var el = root.querySelector('[data-pattern-a-view-all]');
    if (!el) return;
    el.href = '/pages/reviews' + window.location.search;
  }

  function currentSnap() {
    return window.VioriFilters ? window.VioriFilters.getState() : {
      sort_by: '', scalp_types: [], concerns: [], benefits: [],
      product_types: [], hair_likenesses: []
    };
  }

  var subscribed = false;
  function boot() {
    /* Initial render. Top Matches' synchronous boot at the bottom of the
       controller renders into its track before this fires (controller is
       loaded with `defer` and runs first), so the mirror finds the picks
       already in place. */
    processPatternA(currentSnap());

    /* Re-render whenever Top Matches finishes rendering its picks. Using
       this event (instead of subscribing to filter-state changes directly)
       guarantees we run AFTER Top Matches has populated its track and
       AFTER both stagings have been swapped by the SRA fetch — so the
       mirror is reading from current data on both sides. */
    if (!subscribed) {
      window.addEventListener('vioriTopMatchesRendered', function () {
        processPatternA(currentSnap());
      });
      subscribed = true;
    }
  }

  /* Public hook: re-render the visible track from staging using the current
     filter state. Called by the section script on shopify:section:load so
     theme-editor saves don't leave the track empty. Does NOT re-subscribe. */
  window.VioriPatternA = {
    refresh: function () { processPatternA(currentSnap()); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
